export enum EStatus {
    DISABLED = 0,
    ENABLED = 1
}

export const EStatusLabels = {
    [EStatus.DISABLED]: 'enum.status.disabled',
    [EStatus.ENABLED]: 'enum.status.enabled'
}
